//todo replace wordings (Kostenstelle, etc.)
/* use format validatorReceiver for naming errormessages */
export default {
	amountTooHigh: "Zu viele Einträge (max. %val%)",
	amountTooLow: "Nicht genug Einträge (min. %val%)",
	changeNotAllowed: "Ändern nicht erlaubt",
	formatInvalid: "Format ungültig",
	formatDate: "Datum ungültig",
	formatTime: "Zeitpunkt ungültig",
	formatDuration: "Zeitspanne ungültig",
	missingValue: "Eingabe fehlt",
	missingValueOfAny: "Mindestens eines dieser Felder ausfüllen",
	missingValueXOR: "Nur eines dieser Felder ausfüllen",
	missingStuart: "Stundenart auswählen",
	missingBuart: "Buchungsart auswählen",
	missingStartTime: "Startzeit auswählen",
	missingComment: "Bemerkung auswählen",
	missingDate: "Datum auswählen",
	missingTime: "Zeitpunkt auswählen",
	missingDuration: "Zeitspanne auswählen",
	missingDurationEndTime: "Zeitspanne/Endzeit auswählen",
	missingPersNr: "Person auswählen",
	notAvailableValue: "Dieser Wert steht nicht zur Auswahl",
	tooShortValue: "Wert zu kurz (min. Länge %val%)",
	tooLongValue: "Wert zu lange (max. Länge %val%)",
	tooHighValue: "Wert zu groß (max. %val%)",
	tooHighDuration: "Maximale Dauer überschritten",
	tooLowValue: "Wert zu klein (min. %val%)",
	tooLowDuration: "Minimale Dauer unterschritten",
	tooManyDecimalPlaces: "Zu viele Nachkommastellen (max. %val%)",
	endBeforeStartDate: "Das Enddatum darf nicht vor dem Beginn liegen",
	collisionBlockedSaving: "Eine Kollision hat das Sichern verhindert",
	errorTransmission: "Fehler beim Übertragen der Daten",
	maxBlobSizeExceeded: 'Der Anhang ist zu groß (max. %val%)',
	wrongSequence: "Die Eingaben müssen aufeinanderfolgend eingegeben werden",
	wrongTimeSequence: "Die Zeitangaben müssen aufeinanderfolgend eingegeben werden",
};